;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.dropUp = (function () {
    const initialize = function () {
      let $openButton = null
      $('.js-dropUpButton').on('click', function (e) {
        e.preventDefault()

        // Close whatever dropdown is open at the moment.
        if ($openButton) {
          $openButton.removeClass('is-open')
        }

        // If we didn't just close this one, it becomes the new open one.
        if (!$openButton || !$openButton.is($(this).closest('.button').first())) {
          $openButton = $(this).closest('.button').first()
          $openButton.toggleClass('is-open')
        } else {
          // Otherwise, clear the buffer.
          $openButton = null
        }

        return false
      })

      // $('body').on('click', function(e) {
      //   console.log('1');
      //   if($openButton){
      //     console.log('2');
      //      $openButton.removeClass('is-open');
      //      !$openButton;
      //    }
      // }).find($openButton).children().on('click', function(e){
      //   console.log('3');
      //   return false;
      // });

      $('.js-dropUpButtonClose').on('click', function (e) {
        e.preventDefault()
        $(this).closest('.button').removeClass('is-open')
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.dropUp.initialize()
  })
}(jQuery, window))
